import {
    FETCH_PUBLIC_PAGE_BRAND_BANNER
} from '../actions/types'

const initialState = {}

const publicBannerReducer = (state = initialState, action) => {
    switch(action.type){
        case FETCH_PUBLIC_PAGE_BRAND_BANNER:
            return {
                ...state, [action.payload.slug]: action.payload
            }
        default:
            return state
    }
}

export default publicBannerReducer